define([
    'moment',
    'legacy/utils',
    'dateformatter'
], function (moment, utils, dateformatter) {
    dateformatter = dateformatter.default;
    var wrapper;

    function wrap(m) {
        return _.extend(m, {
            formatDateApi: function () {
                return this.format(dateformatter.momentDateApiFormat());
            },

            formatTimeApi: function () {
                return this.format(dateformatter.momentTimeApiFormat());
            },

            formatDateTimeApi: function () {
                return this.format(dateformatter.momentDateTimeApiFormat());
            },

            formatMonthApi: function () {
                return this.format(dateformatter.momentMonthApiFormat());
            },

            formatDate: function () {
                return this.format(dateformatter.momentDateFormat());
            },

            formatDateShort: function () {
                return this.format(dateformatter.momentDateFormatShort());
            },

            formatDateMonth: function () {
                return this.format(dateformatter.momentDateMonthFormat());
            },

            formatGroupedMonths: function () {
                return this.format(dateformatter.momentDateGroupedMonthsFormat());
            },

            // moment.js can't format quarters, so we format it as month divided by 4 in day field
            formatGroupedQuarters: function () {
                var quarter = Math.ceil((this.month() - 1) / 3) + 1;
                return this.clone().date(quarter).format(dateformatter.momentDateGroupedQuartersFormat());
            },

            formatGroupedYears: function () {
                return this.format(dateformatter.momentDateGroupedYearsFormat());
            },

            formatDatetime: function () {
                return this.format(dateformatter.momentDatetimeFormat());
            },

            formatTime: function (options) {
                return this.format(dateformatter.momentTimeFormat(options));
            },

            firstDayOfWeek: function () {
                return moment().lang()._week.dow;
            },

            replaceZone: function (offset) {
                var delta = -offset - this.zone(),
                    replaced = wrapper(this).zone(delta);
                return replaced.add('minutes', delta);
            },

            daysOfWeek: function(options) {
                var firstDay = this.firstDayOfWeek(),
                    lang = moment().lang(),
                    weekdayFunc;

                options = _.defaults(options || {}, { 'long': true });

                if (options.short) {
                    weekdayFunc = lang.weekdaysShort;
                }
                else if (options.min) {
                    weekdayFunc = lang.weekdaysMin;
                } else {
                    weekdayFunc = lang.weekdays;
                }

                // on server side we assume that 0-day is Monday
                // in moment.js 0-day is:
                // 1) Sunday (when using moment().day())
                // 2) the first locale-dependent day of week (Sunday for 'en' and Monday for 'ru')
                return _.map(_.range(utils.daysInWeek), function (i) {
                    var serverDayId = (i + firstDay + utils.daysInWeek - 1) % utils.daysInWeek;
                    return { id: serverDayId, name: weekdayFunc.call(lang, moment().weekday(i), 'nominative') };
                });
            },

            dateRange: function (from, to) {
                return { from: this.formatDateApi.call(from), to: this.formatDateApi.call(to) };
            },

            pastMonth: function () {
                var from = this.clone().add('months', -1).date(1),
                    to = this.clone().date(1).add('days', -1);
                return this.dateRange(from, to);
            },

            thisMonth: function () {
                var from = this.clone().date(1),
                    to = from.clone().add('months', 1).add('days', -1);
                return this.dateRange(from, to);
            },

            isBetween(date_1, date_2) {
                return this > moment(date_1) && this < moment(date_2);
            },

            isAfter(value) {
                return this > value;
            },

            weekend() {
                // for different locales, the numbers of days of the week will be different
                // for example for `en` locale it will be `[0, 6]` but for `ru` locale it will be `[5, 6]`
                const isISO = moment().weekday() === moment().isoWeekday();
                return isISO ? [0, 6] : [5, 6];
            },

            clone () {
                return wrapper(this);
            }
        });
    }


    wrapper = function () { return wrap(moment.apply(null, arguments)); };
    Object.setPrototypeOf(wrapper, moment);
    wrapper.utc = function () { return wrap(moment.utc.apply(null, arguments)); };
    wrapper.duration = function () { return wrap(moment.duration.apply(null, arguments)); };
    wrapper.duration.isDuration = moment.isDuration.bind(moment);
    wrapper.toISOString = wrapper.toIsoString;

    const durationProto = Object.getPrototypeOf(moment.duration());
    durationProto.toISOString = durationProto.toIsoString;

    return wrapper;
});
